import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_action = _resolveComponent("v-list-item-action")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, { "close-on-content-click": true }, {
    activator: _withCtx(({ props }) => [
      _createElementVNode("div", _mergeProps(props, { style: {"background-color":"#0099D5","height":"72px","margin-left":"-16px","margin-right":"1em","align-items":"center","padding-left":"2em","padding-right":"2em"} }), [
        _createElementVNode("img", {
          src: require('../../assets/IRIS_logo.svg'),
          style: {"height":"32px","margin-top":"20px"}
        }, null, 8, _hoisted_1)
      ], 16)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_list, {
        class: "overflow-y-auto",
        style: {"padding":"0","max-height":"95vh"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list_subheader, null, {
            default: _withCtx(() => [
              _createTextVNode(" IRIS Platform " + _toDisplayString(_ctx.getVersion) + " (" + _toDisplayString(_ctx.getBuildDate) + ") ", 1)
            ]),
            _: 1
          }),
          (_ctx.isPermissionManager || _ctx.isGlobalCalculator || _ctx.isLogViewer)
            ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 0,
                disabled: _ctx.$route.name === 'Default',
                onClick: _ctx.goHome
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_action, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                          _createTextVNode("mdi-home", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", null, [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                        _createTextVNode("Home", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]))
            : _createCommentVNode("", true),
          (_ctx.getUser && _ctx.getUser.roles && (_ctx.isPermissionManager || _ctx.isGlobalCalculator || _ctx.isLogViewer))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_v_divider),
                _createVNode(_component_v_list_subheader, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("message.globalAdmin")), 1)
                  ]),
                  _: 1
                }),
                (_ctx.isLogViewer)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 0,
                      disabled: _ctx.$route.name == 'AdminLog',
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push({ name: 'AdminLog'})))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_action, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                _createTextVNode("mdi-text-box-outline", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", null, [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("message.log")), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.isLogViewer)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 1,
                      disabled: _ctx.$route.name == 'AdminUsage',
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push({ name: 'AdminUsage'})))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_action, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                _createTextVNode("mdi-chart-bar", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", null, [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("message.usage")), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.isPermissionManager)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 2,
                      disabled: _ctx.$route.name == 'AdminLogins',
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push({ name: 'AdminLogins'})))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_action, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                _createTextVNode("mdi-account-key", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", null, [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                              _createTextVNode("Logins", -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.isPermissionManager)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 3,
                      disabled: _ctx.$route.name == 'AdminUserAccess',
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.router.push({ name: 'AdminUserAccess'})))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_action, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                _createTextVNode("mdi-account-search", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", null, [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                              _createTextVNode("User access", -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.isPermissionManager)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 4,
                      disabled: _ctx.$route.name == 'AdminRoles',
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.router.push({ name: 'AdminRoles'})))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_action, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                _createTextVNode("mdi-shield-account", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", null, [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                              _createTextVNode("Roles", -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.isPermissionManager)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 5,
                      disabled: _ctx.$route.name == 'AdminGroups',
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.router.push({ name: 'AdminGroups'})))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_action, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                _createTextVNode("mdi-account-group", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", null, [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                              _createTextVNode("User groups", -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.isPermissionManager)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 6,
                      disabled: _ctx.$route.name == 'AdminModels',
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.router.push({ name: 'AdminModels'})))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_action, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                _createTextVNode("mdi-file-multiple", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", null, [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                              _createTextVNode("Models", -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.isPermissionManager)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 7,
                      disabled: _ctx.$route.name == 'AdminApiKeys',
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.router.push({ name: 'AdminApiKeys'})))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_action, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                _createTextVNode("mdi-key-chain", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", null, [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                              _createTextVNode("API keys", -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.isGlobalCalculator)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 8,
                      disabled: _ctx.$route.name == 'ScenarioStatus',
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.router.push({ name: 'ScenarioStatus'})))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_action, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                _createTextVNode("mdi-list-status", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", null, [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                              _createTextVNode("Scenario's status", -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}